import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface Restaurant {
  restaurant_id: string
  name: string
  owner_user_id?: string
  address_line1: string
  city: string
  state: string
  pin_code: string
  latitude?: number
  longitude?: number
  contact_phone: string
  contact_email: string
  opening_hours: string
  closing_hours: string
  restaurant_types: string[]
  cuisines: string[]
  price_range: 'budget' | 'moderate' | 'expensive' | 'luxury'
  images?: string[]
  profile_image?: string
  amenities: string[]
  days_open: string[]
  status: 'pending' | 'approved' | 'rejected' | 'paused'
  created_at: string
  updated_at: string
  cost_for_two?: number
  rating?: number
  auto_approve_reservation?: boolean
  max_table_book?: number
  vibe_id?: string[]
}

export interface User {
  id: string
  email: string
  role: string
}

// Admin role types
export type AdminRole = 'super_admin' | 'restaurant_admin'

export interface AdminUser {
  id: string
  email: string
  name: string
  role: AdminRole
  is_active: boolean
  created_at: string
  updated_at: string
  created_by?: string
  auth_user_id: string
}

export interface UserProfile {
  id: string
  name: string
  mobile?: string
  email: string
  age?: number
  gender?: string
  is_adult?: boolean
  bio?: string
  photo_url?: string
  occupation?: string
  education?: string
  languages?: string[]
  interests?: string[]
  average_rating?: number
  review_count?: number
  created_at: string
  updated_at: string
  album?: string[]
  last_seen?: string
  user_status: 'pending' | 'approved' | 'rejected' | 'paused'
  location?: string
  city?: string
  state?: string
  notification_settings?: {
    matches?: boolean
    bookings?: boolean
    messages?: boolean
    security?: boolean
    promotions?: boolean
  }
  pending_photo_url?: string
  photo_approval_status?: 'none' | 'pending' | 'approved' | 'rejected'
  photo_rejected_reason?: string
  photo_approved_at?: string
  photo_approved_by?: string
  country_code?: string
  album_visibility?: 'public' | 'private'
}

// Profile Photo Moderation types
export interface ProfilePhotoModeration {
  id: string
  user_id: string
  photo_url: string
  status: 'pending' | 'approved' | 'rejected'
  created_at: string
  reviewed_by?: string
  reviewed_at?: string
  rejection_reason?: string
  updated_at: string
}

// Combined type for photo review with user details
export interface PhotoReviewItem {
  moderation_id: string
  user_id: string
  photo_url: string
  submitted_at: string
  user_name: string
  user_email: string
  age?: number
  gender?: string
  mobile: string
  current_photo_url?: string
}

// Moderation statistics
export interface ModerationStats {
  pending_count: number
  approved_count: number
  rejected_count: number
  approved_today: number
  rejected_today: number
  avg_review_time_minutes?: number
}
